window.arPricePerCreditFormatter = function(value, row) {
    let html = '';
    if (row.discount_type) {
        html += '<span class="text-decoration-line-through text-muted">';
        html += '&euro;';
        html += ' ';
        html += row.price_per_credit;
        html += '</span>';
        html += ' ';
        html += '&euro;';
        html += ' ';
        html += row.price_per_credit_discount;
    } else {
        html += '&euro;';
        html += ' ';
        html += row.price_per_credit;
    }
    return html;
}
